import { TxType } from '../types/TxType'

const TxTypeTexts = {
  // NFCS
  [TxType.NFCSMinted]: 'NFCS minted',

  // PoolInvestor
  [TxType.BorrowSuccessful]: 'Borrow',
  [TxType.InterestRateAnnualSet]: 'Interest rate annual set',
  [TxType.LiquidityDeposited]: 'Liquidity deposited',
  [TxType.LiquidityWithdrawn]: 'Liquidity withdrawn',
  [TxType.ReserveRateSet]: 'Reserve rate set',
  [TxType.StakingRewardClaimed]: 'Staking reward claimed',

  // RevenueManager
  [TxType.AcceptedCollateralAdded]: 'Collateral added',
  [TxType.AcceptedCollateralRemoved]: 'Collateral removed',
  [TxType.BalancingFundsRequested]: 'Balancing funds requested',

  // RociPayment
  [TxType.Liquidated]: 'Liquidated',
  [TxType.CollateralDeposited]: 'Collateral deposted',
  [TxType.CollateralWithdrawn]: 'Collateral withdrawn',
  [TxType.LoanRepaid]: 'Loan repaid',

  // ScoreDB
  [TxType.ScoreUpdated]: 'Score updated',

  // Unknown
  [TxType.Unknown]: 'Unknown',
}

export function getTxTypeDisplayText(type: TxType) {
  return TxTypeTexts[type]
}
